$(function () {

    // Search bar
    if ($('.search-row').hasClass('collapsed')) {
        $('.search-row.collapsed .hotel-search-wrap .form-group input, .search-row.collapsed .hotel-search-wrap .form-group select')
            .attr('tabindex', '-1')
            .attr('aria-disabled', 'true');
    }

    $('.btn-new-search').on('click',function (e){
        $('.search-row').removeClass('collapsed');
        $('.search-row').addClass('expanded');
        $('.search-row .hotel-search-wrap .form-group input, .search-row .hotel-search-wrap .form-group select')
            .attr('tabindex', '0')
            .attr('aria-disabled', 'false');
        e.preventDefault(); 
        return false;
    })

    // Compare button
    $('.compare-button').on('click', function(e) {
        $(this).toggleClass('clicked');   
        e.preventDefault(); 
        return false;
    });

    // Filters drawer
    $('.open-fliters-btn, .map-filters-btn').on('click', function(e) {
        openFilters();
        e.preventDefault(); 
        return false;
    });

   $('.filters-close-btn').on('click', function(e) {
        closeFilters();
        e.preventDefault(); 
        return false;
    });
  
    $( document ).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) { // ESC
            closeFilters();
        }
    });

    // View switcher
    $('.search-results-view-switcher button').on('click',function (e){
        $('.search-results-view-switcher button').removeClass('active');
        $(this).addClass('active');           
        e.preventDefault(); 
        return false;
    });

    $('.detail-view-btn').on('click',function (e){
        $('.detail-view').removeClass('list-view');
        $('.detail-view').show();
        $('.pagination-wrapper').show();
        $('.map-view').hide();
        $('.detail-view-btn').focus();       
        e.preventDefault(); 
        return false;
    });

    $('.list-view-btn').on('click',function (e){
        $('.detail-view').addClass('list-view');
        $('.detail-view').show();
        $('.pagination-wrapper').show();
        $('.map-view').hide();
        $('.list-view-btn').focus();       
        e.preventDefault(); 
        return false;
    });

    $('.map-view-btn').on('click',function (e){
        $('.map-view').show();
        $('.detail-view').hide();
        $('.pagination-wrapper').hide();
        $('.map-view-btn').focus();  
        e.preventDefault(); 
        return false;
    });

    // Large map
    $('.hotel-search-map-view').on('click',function (e){
        e.preventDefault(); 
        showHotelSearchMap();
        return false;
    });

    $('.return-to-list-btn').on('click',function (e){
        closeSearchMap();                  
        e.preventDefault(); 
        return false;
    });

    $('.hotel-single-map-view').on('click',function (e){
        showSingleMap()
        e.preventDefault(); 
        return false;
    });

    $('.return-to-single-btn').on('click',function (e){
        closeSingleMap();
        e.preventDefault(); 
        return false;
    });

 
    $( document ).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) { // ESC
            closeSearchMap();
            closeSingleMap();
        }
    });

    // Photo gallery
    $('.all-photos-btn').on('click',function (e){
        //load lazy images
        $("img[_gallerysrc]").map(function () {
            $(this).attr("src",$(this).attr("_gallerysrc")).removeAttr("_gallerysrc");
        });               


        $('.photo-gallery-modal-container').show();            
        e.preventDefault(); 
        return false;
    });

    function closeGallery() {
        $('.photo-gallery-modal-container').hide();
        $('.all-photos-btn').focus();
    }

    $('.gallery-modal-close-btn').on('click',function (e){
        closeGallery()  
        e.preventDefault(); 
        return false;
    });


    $( document ).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) { // ESC
            closeGallery();
        }
    });

    // Meetings room table
    $('.event-room-table .table-row:nth-of-type(n+7)').hide();
    $('.table-show-all-btn').on('click',function (e){
        $('.event-room-table .table-row').show();
        $('.table-fade').hide();
        $(this).hide();
        $('.table-show-less-btn').show();   
        e.preventDefault(); 
        return false;
    });

    $('.table-show-less-btn').on('click',function (e){
        $('.event-room-table .table-row:nth-of-type(n+7)').hide();
        $('.table-fade').show();
        $(this).hide();
        $('.table-show-all-btn').show();   
        e.preventDefault(); 
        return false;
    });

    // Add class to single page gallery based on number of images
    if ($('.photo-gallery').length) { 
        var count = $('.photo-gallery .gallery-image-wrapper').length; 
        $('.photo-gallery').addClass('gallery-' + count + '-up'); 
    }

});


function closeSearchMap() {
    bMapView=false;
    aview="D";
    updateDynaResults()
                                                  
    $('.filters').removeClass('large-map-visible');  
    $('.hide-full-map').show();    
    $('.hotel-search-map-view').focus(); 
    window.removeEventListener('resize',resizeSearchMap);
    $(".large-map-holder").hide()
    $("body").css('overflow','unset');        
    $(".navbar.navbar-default").removeClass("affix").addClass("affix-top");
    window.scrollTo(0,0);                   
}

function closeSingleMap() {      
    $('.hide-full-map').show();    
    $('.hotel-single-map-view').focus();  
     window.removeEventListener('resize',resizeSearchMap);
    $(".large-map-holder").hide()
    $("body").css('overflow','unset');        
    $(".navbar.navbar-default").removeClass("affix").addClass("affix-top");
    window.scrollTo(0,0);      

}


function showSingleMap() {
    $('.return-to-single-btn').focus();   
    $('.hide-full-map').hide();

    $(".large-map-holder").show()
    $("body").css('overflow','hidden');
    bMapView=true;
    aview="M";

    window.addEventListener('resize', resizeSearchMap);  
    resizeSearchMap()

    if (!delaymaploaded){loadthismap();}
    else{updateDynaResults();}   
    

 }

function showHotelSearchMap(){          
    $(".filter-results-title-m").html($(".hotel-results-heading-count .title-xxl").html())
    $(".results-count-lbl").html("Updating Hotels...")
    $(".navbar.navbar-default").removeClass("affix-top").addClass("affix");

    $('.hide-full-map').hide();
    $('.return-to-list-btn').focus();
    $('.filters').addClass('large-map-visible'); 

    $(".large-map-holder").show()
    $("body").css('overflow','hidden');
    bMapView=true;
    aview="M";

    window.addEventListener('resize', resizeSearchMap);  
    resizeSearchMap()

    if (!delaymaploaded){loadthismap();}
    else{updateDynaResults();}      
}

function openFilters(){
    $('.open-filters-holder').show();
    $('.hotel-results-content-sidebar-wrap .filters').addClass('expanded');
   // $('.filters-blocker').show();
    //$('body').addClass( 'filters-open' );       
   // $(".offset-container").addClass("offset-containerz").removeClass( 'offset-container' );  
}

function closeFilters() {
    $('.open-filters-holder').hide();
   $('.hotel-results-content-sidebar-wrap .filters').removeClass('expanded');

    //$('body').removeClass( 'filters-open' );         
    //   $(".offset-containerz").addClass("offset-container").removeClass( 'offset-containerz' );  
    //$('.open-fliters-btn').focus();
    // $('.filters-blocker').hide();
   
}